const { same } = require('../utils');

exports.computeScaleYFromCanvasStateItems = canvasStateItems => same(canvasStateItems, 'scaleY');
